/**
 * SubformulaCard — collapsible title + description + blocks builder
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, useState } from 'react';
import type { FormulaBlockNode, FormulaSubformula } from '@trafficpulse/shared';

import SubformulaCardBody from './SubformulaCardBody';
import SubformulaCardHeader from './header';

export interface SubformulaCardProps {
  sub: FormulaSubformula;
  /** Effective weight (%) shown in the header stepper (normalized share). */
  weight: number;
  onChange: (patch: Partial<FormulaSubformula>) => void;
  onAstChange: (ast: FormulaBlockNode | null) => void;
  onWeightChange: (next: number) => void;
  onRemove: () => void;
}

const SubformulaCard: FC<SubformulaCardProps> = ({
  sub,
  weight,
  onChange,
  onAstChange,
  onWeightChange,
  onRemove,
}) => {
  const [expanded, setExpanded] = useState(true);
  const bodyId = `subformula-body-${sub.id}`;
  return (
    <div className="space-y-2 rounded-md border border-border bg-card p-3">
      <SubformulaCardHeader
        bodyId={bodyId}
        expanded={expanded}
        onToggleExpanded={() => setExpanded((v) => !v)}
        name={sub.name}
        onNameChange={(next) => onChange({ name: next })}
        expression={sub.expression}
        weight={weight}
        onWeightChange={onWeightChange}
        onRemove={onRemove}
      />
      <SubformulaCardBody
        bodyId={bodyId}
        collapsed={!expanded}
        sub={sub}
        onChange={onChange}
        onAstChange={onAstChange}
      />
    </div>
  );
};

export default SubformulaCard;
